import { observer } from "mobx-react";
import React from "react";
import { Box } from "@material-ui/core";

type Props = {
  children: React.ReactNode;
  value: number;
  index: number;
};

@observer
class TabPanel extends React.Component<Props> {
  render() {
    const { children, value, index } = this.props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`full-width-tabpanel-${index}`}
        aria-labelledby={`full-width-tab-${index}`}
      >
        {value === index && <Box p={3}>{children}</Box>}
      </div>
    );
  }
}

export default TabPanel;
